import { styled } from '@mui/material';
import {
    GridToolbarContainer,
    GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid-pro';

// Files in the same folder
import { ReactComponent as ExportIcon } from '../assets/icon-export.svg';
import { ReactComponent as FilterIcon } from '../assets/icon-filter.svg';
// Utils
import { getBodyExtraSmallBoldStyles } from '../../../../core/utils/GetTypographyStyles/GetTypographyStyles';
// Types
import { TypographyStyleObject } from '../../../../core/types/TypographyTypes';
import { TriggerGoogleAnalytics4Tag } from '../../../../core/utils/GoogleAnalyticTag';
import { GoogleAnalytics4Tags } from '../../../../core/utils/GoogleAnalyticTag/GoogleAnalytics4Tags';

interface APCustomToolbarProps {
    csvFileName?: string;
    tableName?: string;
}

const StyledGridToolbarContainer = styled(GridToolbarContainer)(({ theme }) => {
    const {
        colours: {
            buttons: {
                outline: { bg, border }
            }
        }
    } = theme;

    const BACKGROUND_COLOR: string = bg;
    const BUTTON_OUTLINE_BORDER: string = border;
    const BODY_EXTRA_SMALL_BOLD_TEXT: TypographyStyleObject = getBodyExtraSmallBoldStyles(theme);

    return {
        alignItems: 'flex-start',
        alignSelf: 'stretch',
        padding: 0,
        'button': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '8px 24px',
            background: BACKGROUND_COLOR,
            borderRadius: 60,
            border: `1px solid ${BUTTON_OUTLINE_BORDER}`,
            ...BODY_EXTRA_SMALL_BOLD_TEXT
        }
    }
});

const APCustomToolbar = ({ csvFileName, tableName }: APCustomToolbarProps): React.JSX.Element => {
    const handleFilterClick = () => {
        if(tableName === 'clientManagement'){
            TriggerGoogleAnalytics4Tag(
                GoogleAnalytics4Tags.clientManagement.name,
                GoogleAnalytics4Tags.eventAction.click,
                GoogleAnalytics4Tags.clientManagement.click.filterTableCTA
            );
        }
    }

    const handleExportClick = () => {
        if (tableName === 'clientManagement') {
            TriggerGoogleAnalytics4Tag(
                GoogleAnalytics4Tags.clientManagement.name,
                GoogleAnalytics4Tags.eventAction.click,
                GoogleAnalytics4Tags.clientManagement.click.exportTableCTA
            );
        }
    }

    return (
        <StyledGridToolbarContainer>
            <GridToolbarFilterButton
                slotProps={{
                    button: {
                        startIcon: (<FilterIcon />),
                        onClick: handleFilterClick
                    }
                }}
            />
            <GridToolbarExport
                slotProps={{
                    button: {
                        startIcon: (<ExportIcon />),
                        onClick: handleExportClick
                    }
                }}
                csvOptions={{
                    fileName: csvFileName
                }}
                printOptions={{
                    disableToolbarButton: true
                }}
            />
        </StyledGridToolbarContainer>
    );
}

export default APCustomToolbar;